export function updateOrAdd(array: any, element: any, key: string) {
  // (1)
  const i = array.findIndex((_element: any) => _element[key] === element[key]);
  if (i > -1)
    array[i] = element; // (2)
  else array.unshift(element);
}
